import { getEnv } from '@pcln/environment'
import useSSO from '../useSSO'

function useLogout () {
  const { logoutUrl, apiKey = {} } = useSSO()

  const env = getEnv()
  const isProd = env === 'prod' || env === 'preprod'

  const envLogoutUrl = isProd
    ? logoutUrl && logoutUrl.prod
    : logoutUrl && logoutUrl.qa
  const envApiKey = isProd ? apiKey && apiKey.prod : apiKey && apiKey.qa

  function onLogoutClick () {
    // todo: destroy cookie
    if (envApiKey) {
      typeof window === 'object' &&
        window.location.assign(`${envLogoutUrl}${envApiKey}`)
    }
  }

  return { onLogoutClick }
}

export default useLogout
